/* Roundway — Aquafibre concept survey + £500 prize draw (hidden lead page).
   Standalone: does not touch roundway-quiz-engine.js.
   Email is captured on the intro screen, so a partial run still lands as a lead.
   Question types: single | multi | scale | text | rank | price | single_other | note */
(function () {
  'use strict';

  var COHORT = 'aquafibre-survey-2026-09';

  // ---------------------------------------------------------------------------
  // QUESTIONS — edit freely, order is the order shown.
  // ---------------------------------------------------------------------------
  var QUESTIONS = [
    {
      id: 'glp1_taking',
      section: 'Your medication',
      title: 'Are you currently taking, or have you previously taken, a GLP-1 medication?',
      lead: 'For example Mounjaro, Wegovy, Ozempic or Saxenda.',
      type: 'single',
      options: ['Currently taking one', 'I have taken one before', 'No, never']
    },
    {
      id: 'glp1_stage',
      section: 'Your medication',
      title: 'Which best describes you right now?',
      type: 'single',
      options: ['Currently on medication', 'Paused for now', 'Stopped completely', 'Considering starting']
    },
    {
      id: 'side_effects',
      section: 'How it feels',
      title: 'Since starting, which of these have you experienced?',
      type: 'multi',
      options: ['Constipation or irregularity', 'Low energy or fatigue', 'Dehydration', 'Nausea', 'Loss of appetite', 'None of these']
    },
    {
      id: 'discomfort_impact',
      section: 'How it feels',
      title: 'How much has digestive discomfort affected your daily life?',
      lead: 'Bloating, constipation, that heavy feeling.',
      type: 'scale',
      minLabel: 'Not at all',
      maxLabel: 'A great deal'
    },
    {
      id: 'manage_now',
      section: 'How it feels',
      title: 'What do you currently do to manage these side effects, if anything?',
      type: 'text',
      placeholder: 'Anything you have tried, even if it did not work.'
    },
    {
      id: 'current_supplements',
      section: 'How it feels',
      title: 'Do you take any fibre supplement, electrolyte product or multivitamin?',
      type: 'single_other',
      options: ['No, none of those'],
      otherLabel: 'Yes, and it is...',
      otherPlaceholder: 'Which one?'
    },
    {
      id: 'monthly_spend',
      section: 'How it feels',
      title: 'Roughly how much do you spend a month on supplements to support your journey?',
      type: 'single',
      options: ['£0 to £10', '£10 to £25', '£25 to £50', '£50 or more']
    },
    {
      id: 'research_channel',
      section: 'How it feels',
      title: 'Where do you usually research or buy supplements?',
      type: 'single_other',
      options: ['Amazon', 'Brand websites', 'In store', 'Social media recommendations'],
      otherLabel: 'Somewhere else',
      otherPlaceholder: 'Where?'
    },
    {
      id: 'concept',
      section: 'The idea',
      type: 'note',
      title: 'Here is what we are working on.',
      lead: 'A daily powder designed for people on a weight-loss medication journey. One scoop into water each day.',
      body: [
        { h: 'Contains', p: 'Soluble fibre and electrolytes, plus vitamin D3, K2, B12 and selenium.' },
        { h: 'Designed to help with', p: 'Digestive regularity and comfort. Hydration. Filling the nutrient gaps that can open up while eating less.' },
        { h: 'Format', p: 'Powder in a pouch. A scoop and a glass bottle come with your first order.' }
      ],
      cta: 'Got it, next'
    },
    {
      id: 'appeal',
      section: 'The idea',
      title: 'How appealing is a product like this to you?',
      type: 'scale',
      minLabel: 'Not for me',
      maxLabel: 'Very appealing'
    },
    {
      id: 'benefit_priority',
      section: 'The idea',
      title: 'Which benefit matters most to you?',
      type: 'single',
      options: ['Digestive regularity', 'Hydration', 'Micronutrient support', 'All equally']
    },
    {
      id: 'blockers',
      section: 'The idea',
      title: 'What, if anything, would stop you from trying this?',
      type: 'text',
      placeholder: 'Be blunt. This is the most useful answer in the survey.'
    },
    {
      id: 'purchase_pref',
      section: 'The idea',
      title: 'Would you want this as a daily habit, or something you buy as needed?',
      type: 'single',
      options: ['Subscription, every month', 'One-off, when I need it', 'Depends on the price']
    },
    {
      id: 'flavour_rank',
      section: 'Flavour',
      title: 'Rank these flavours, favourite first.',
      lead: 'Tap them in the order you would drink them.',
      type: 'rank',
      options: ['Orange Citrus', 'Berry', 'Lemon-Lime', 'Lemon-Ginger', 'Unflavoured']
    },
    {
      id: 'flavour_missing',
      section: 'Flavour',
      title: 'Any flavour missing that you would want to see?',
      type: 'text',
      placeholder: 'Optional'
    },
    {
      id: 'flavour_dealbreakers',
      section: 'Flavour',
      title: 'Any flavour dealbreakers?',
      lead: 'For example artificial sweeteners, or anything berry.',
      type: 'text',
      placeholder: 'Optional'
    },
    {
      id: 'expected_price',
      section: 'Price',
      title: 'What would you expect to pay for a one-month supply?',
      type: 'price',
      placeholder: '0.00'
    },
    {
      id: 'welcome_kit',
      section: 'Price',
      title: 'Would a welcome kit on us, with scoop, bottle and an extra supplement, affect your decision to try it?',
      type: 'single',
      options: ['Yes, a lot', 'Somewhat', 'Not really']
    },
    {
      id: 'guarantee_importance',
      section: 'Price',
      title: 'How important is a money-back guarantee when trying a new supplement?',
      type: 'scale',
      minLabel: 'Not important',
      maxLabel: 'Essential'
    },
    {
      id: 'age_range',
      section: 'About you',
      title: 'What is your age range?',
      type: 'single',
      options: ['18 to 24', '25 to 34', '35 to 44', '45 to 54', '55 or over']
    },
    {
      id: 'gender',
      section: 'About you',
      title: 'Male or female?',
      type: 'single',
      options: ['Male', 'Female', 'Prefer not to say']
    },
    {
      id: 'notify_launch',
      section: 'About you',
      title: 'Want to be told when this launches, with early access and a discount?',
      type: 'single',
      options: ['Yes please', 'No thanks']
    }
  ];

  function el(root, sel) { return root.querySelector(sel); }

  var UTM_KEY = 'rw_glq_utm';

  function utmFrom(search) {
    var out = {}, p = new URLSearchParams(search || '');
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'ttclid'].forEach(function (k) {
      var v = p.get(k); if (v) out[k] = v.slice(0, 200);
    });
    return out;
  }

  // Remember the link the visitor arrived on, so attribution survives
  // navigation, refreshes and the thank-you step.
  function stickyUtm() {
    var fresh = utmFrom(window.location.search);
    try {
      if (Object.keys(fresh).length) {
        sessionStorage.setItem(UTM_KEY, JSON.stringify(fresh));
        return fresh;
      }
      var saved = JSON.parse(sessionStorage.getItem(UTM_KEY) || '{}');
      return saved && typeof saved === 'object' ? saved : {};
    } catch (e) { return fresh; }
  }


  function noindex() {
    if (document.querySelector('meta[name="robots"][data-glq]')) return;
    var m = document.createElement('meta');
    m.name = 'robots';
    m.content = 'noindex, nofollow';
    m.setAttribute('data-glq', '1');
    document.head.insertBefore(m, document.head.firstChild);
  }

  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  function boot(root) {
    if (!root || root.dataset.glqReady === '1') return;
    root.dataset.glqReady = '1';
    noindex();

    var api = (root.dataset.api || '').replace(/\/$/, '');
    var anon = root.dataset.anon || '';
    var shopDomain = root.dataset.shop || '';
    var pageHandle = root.dataset.handle || 'glp1';
    var termsUrl = root.dataset.terms || '';
    var instagram = root.dataset.instagram || '';

    var stage = el(root, '[data-glq-stage]');
    var bar = el(root, '[data-glq-bar]');
    var barFill = el(root, '[data-glq-fill]');
    var barStep = el(root, '[data-glq-step]');
    var screens = { intro: el(root, '[data-glq-intro]'), thanks: el(root, '[data-glq-thanks]') };

    var answers = {};
    var email = '';
    var consent = true;
    var index = -1;
    var total = QUESTIONS.filter(function (q) { return q.type !== 'note'; }).length;

    function send(payloadStage) {
      if (!email) return Promise.resolve({});
      return fetch(api + '/glp1-lead', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', apikey: anon, Authorization: 'Bearer ' + anon },
        body: JSON.stringify({
          email: email,
          answers: answers,
          cohort: COHORT,
          stage: payloadStage,
          consent: consent,
          utm: stickyUtm(),
          page_handle: pageHandle,
          referrer: (document.referrer || '').slice(0, 500),
          shopify_domain: shopDomain,
          hp: ''
        })
      }).then(function (r) { return r.json().catch(function () { return {}; }); });
    }

    // Survey completion event: virtual pageview at /survey/thank-you + standard
    // conversion events, so GA4 / GTM / Meta / Shopify analytics can all key off it.
    // Meta: fires the standard `Lead` event (optimisable at Ad Set level) once on
    // completion — the Meta "Survey Completed" conversion for this campaign.
    var surveyLeadFired = false;
    function trackComplete() {
      var THANKS_PATH = '/survey/thank-you';
      var payload = { cohort: COHORT, page_handle: pageHandle, survey: 'aquafibre' };
      try { window.history.replaceState({ glq: 1 }, '', THANKS_PATH + window.location.search); } catch (e) {}
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'survey_complete', page_path: THANKS_PATH, survey_cohort: COHORT });
        window.dataLayer.push({ event: 'virtual_pageview', page_path: THANKS_PATH, page_title: 'Survey thank you' });
      } catch (e) {}
      try { if (typeof window.gtag === 'function') { window.gtag('event', 'page_view', { page_path: THANKS_PATH, page_title: 'Survey thank you' }); window.gtag('event', 'survey_complete', payload); } } catch (e) {}
      try {
        if (!surveyLeadFired && typeof window.fbq === 'function') {
          surveyLeadFired = true;
          window.fbq('track', 'Lead', { content_name: 'Aquafibre survey', content_category: COHORT, status: 'completed' });
        }
      } catch (e) {}
      try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') { window.Shopify.analytics.publish('survey_complete', payload); } } catch (e) {}
      try { window.dispatchEvent(new CustomEvent('rw:survey-complete', { detail: payload })); } catch (e) {}
    }

    function progress() {

      if (index < 0) { bar.classList.add('is-hidden'); return; }
      var answered = QUESTIONS.slice(0, index).filter(function (q) { return q.type !== 'note'; }).length;
      bar.classList.remove('is-hidden');
      barFill.style.width = Math.round((answered / total) * 100) + '%';
      var q = QUESTIONS[index];
      if (barStep) {
        barStep.textContent = q && q.type !== 'note'
          ? (q.section || '') + ' · ' + Math.min(answered + 1, total) + ' of ' + total
          : (q && q.section) || '';
      }
    }

    function show(node) {
      Array.prototype.forEach.call(root.querySelectorAll('.glq-screen'), function (s) { s.classList.remove('is-live'); });
      stage.innerHTML = '';
      if (node === screens.intro || node === screens.thanks) { node.classList.add('is-live'); return; }
      stage.appendChild(node);
      node.classList.add('is-live');
      try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    }

    function head(wrap, q) {
      var h = document.createElement('h2');
      h.textContent = q.title;
      wrap.appendChild(h);
      if (q.lead) {
        var p = document.createElement('p');
        p.className = 'glq-lead';
        p.textContent = q.lead;
        wrap.appendChild(p);
      }
    }

    function pill(label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'glq-pill glq-next';
      b.textContent = label || 'Continue';
      return b;
    }

    function skipLink(fn) {
      var s = document.createElement('button');
      s.type = 'button';
      s.className = 'glq-ghost';
      s.textContent = 'Skip this one';
      s.addEventListener('click', fn);
      return s;
    }

    function questionScreen(q) {
      var wrap = document.createElement('div');
      wrap.className = 'glq-screen';
      head(wrap, q);

      if (q.type === 'note') {
        var box = document.createElement('div');
        box.className = 'glq-concept';
        (q.body || []).forEach(function (row) {
          var b = document.createElement('div');
          var hh = document.createElement('b');
          hh.textContent = row.h;
          var pp = document.createElement('span');
          pp.textContent = row.p;
          b.appendChild(hh); b.appendChild(pp);
          box.appendChild(b);
        });
        wrap.appendChild(box);
        var go = pill(q.cta || 'Continue');
        go.addEventListener('click', advance);
        wrap.appendChild(go);
        return wrap;
      }

      if (q.type === 'single' || q.type === 'multi' || q.type === 'single_other') {
        var picked = [];
        var list = document.createElement('div');
        list.className = 'glq-opts';
        var next = pill(q.type === 'multi' ? 'Continue' : 'Continue');

        q.options.forEach(function (opt) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'glq-opt';
          b.innerHTML = '<i></i><span></span>';
          b.querySelector('span').textContent = opt;
          b.addEventListener('click', function () {
            if (q.type === 'multi') {
              var at = picked.indexOf(opt);
              if (at > -1) { picked.splice(at, 1); b.classList.remove('is-on'); }
              else { picked.push(opt); b.classList.add('is-on'); }
              next.disabled = picked.length === 0;
              return;
            }
            if (other) { other.classList.remove('is-on'); otherWrap.classList.remove('is-live'); }
            answers[q.id] = opt;
            advance();
          });
          list.appendChild(b);
        });
        wrap.appendChild(list);

        var other = null, otherWrap = null;
        if (q.type === 'single_other') {
          other = document.createElement('button');
          other.type = 'button';
          other.className = 'glq-opt';
          other.innerHTML = '<i></i><span></span>';
          other.querySelector('span').textContent = q.otherLabel || 'Other';
          list.appendChild(other);

          otherWrap = document.createElement('div');
          otherWrap.className = 'glq-inline';
          var inp = document.createElement('input');
          inp.type = 'text';
          inp.maxLength = 160;
          inp.placeholder = q.otherPlaceholder || '';
          otherWrap.appendChild(inp);
          wrap.appendChild(otherWrap);

          other.addEventListener('click', function () {
            Array.prototype.forEach.call(list.children, function (c) { c.classList.remove('is-on'); });
            other.classList.add('is-on');
            otherWrap.classList.add('is-live');
            inp.focus();
            next.disabled = false;
          });
          next.disabled = true;
          next.addEventListener('click', function () {
            var v = (inp.value || '').trim();
            answers[q.id] = v ? (q.otherLabel === 'Somewhere else' ? v : 'Yes: ' + v) : (q.otherLabel || 'Other');
            advance();
          });
          wrap.appendChild(next);
          return wrap;
        }

        if (q.type === 'multi') {
          next.disabled = true;
          next.addEventListener('click', function () { answers[q.id] = picked.slice(); advance(); });
          wrap.appendChild(next);
        }
        return wrap;
      }

      if (q.type === 'scale') {
        var row = document.createElement('div');
        row.className = 'glq-scale';
        for (var n = 1; n <= 5; n++) {
          (function (val) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'glq-dot';
            b.textContent = String(val);
            b.addEventListener('click', function () { answers[q.id] = val; advance(); });
            row.appendChild(b);
          })(n);
        }
        wrap.appendChild(row);
        var ends = document.createElement('div');
        ends.className = 'glq-ends';
        ends.innerHTML = '<span></span><span></span>';
        ends.children[0].textContent = q.minLabel || '1';
        ends.children[1].textContent = q.maxLabel || '5';
        wrap.appendChild(ends);
        return wrap;
      }

      if (q.type === 'text') {
        var ta = document.createElement('textarea');
        ta.className = 'glq-textarea';
        ta.rows = 4;
        ta.maxLength = 600;
        ta.placeholder = q.placeholder || '';
        wrap.appendChild(ta);
        var tnext = pill('Continue');
        tnext.addEventListener('click', function () {
          var v = (ta.value || '').trim();
          if (v) answers[q.id] = v.slice(0, 600);
          advance();
        });
        wrap.appendChild(tnext);
        wrap.appendChild(skipLink(advance));
        return wrap;
      }

      if (q.type === 'price') {
        var pw = document.createElement('div');
        pw.className = 'glq-price';
        pw.innerHTML = '<span>£</span>';
        var pin = document.createElement('input');
        pin.type = 'text';
        pin.inputMode = 'decimal';
        pin.maxLength = 8;
        pin.placeholder = q.placeholder || '0.00';
        pw.appendChild(pin);
        wrap.appendChild(pw);
        var pnext = pill('Continue');
        pnext.addEventListener('click', function () {
          var v = (pin.value || '').replace(/[^0-9.]/g, '');
          if (v) answers[q.id] = '£' + v;
          advance();
        });
        wrap.appendChild(pnext);
        wrap.appendChild(skipLink(advance));
        return wrap;
      }

      if (q.type === 'rank') {
        var order = [];
        var rlist = document.createElement('div');
        rlist.className = 'glq-opts glq-rank';
        var rnext = pill('Continue');
        rnext.disabled = true;

        function paint() {
          Array.prototype.forEach.call(rlist.children, function (b) {
            var opt = b.dataset.opt;
            var at = order.indexOf(opt);
            b.classList.toggle('is-on', at > -1);
            b.querySelector('i').textContent = at > -1 ? String(at + 1) : '';
          });
          rnext.disabled = order.length < 1;
          rnext.textContent = order.length === 0 ? 'Tap your favourite first'
            : order.length === q.options.length ? 'Continue'
            : 'Continue with ' + order.length + ' ranked';
        }

        q.options.forEach(function (opt) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'glq-opt';
          b.dataset.opt = opt;
          b.innerHTML = '<i></i><span></span>';
          b.querySelector('span').textContent = opt;
          b.addEventListener('click', function () {
            var at = order.indexOf(opt);
            if (at > -1) order.splice(at, 1); else order.push(opt);
            paint();
          });
          rlist.appendChild(b);
        });
        wrap.appendChild(rlist);
        rnext.addEventListener('click', function () { answers[q.id] = order.slice(); advance(); });
        wrap.appendChild(rnext);
        paint();
        return wrap;
      }

      return wrap;
    }

    function finalScreen() {
      var wrap = document.createElement('div');
      wrap.className = 'glq-screen';
      wrap.innerHTML =
        '<p class="glq-eyebrow">That is everything</p>' +
        '<h2>Thank you. Shall we enter you into the draw?</h2>' +
        '<p class="glq-lead">We will send the £500 hotels.com voucher to <b class="glq-em"></b> if you win. The winner is announced on 25 September.</p>' +
        '<label class="glq-check"><input type="checkbox" checked>' +
        '  <span>Yes, email me about the launch and GLP-1 support. Unsubscribe any time.</span></label>' +
        '<button type="button" class="glq-pill" style="width:100%;max-width:420px">Submit and enter the draw</button>' +
        '<p class="glq-err" data-glq-err></p>' +
        (termsUrl
          ? '<p class="glq-note">No purchase necessary. UK residents 18+. One entry per person. <a href="' + termsUrl + '" target="_blank" rel="noopener">Prize draw terms</a>.</p>'
          : '<p class="glq-note">No purchase necessary. UK residents 18+. One entry per person.</p>');

      wrap.querySelector('.glq-em').textContent = email;
      var box = wrap.querySelector('.glq-check input');
      var btn = wrap.querySelector('button.glq-pill');
      var err = wrap.querySelector('[data-glq-err]');
      btn.addEventListener('click', function () {
        consent = !!box.checked;
        btn.disabled = true; btn.textContent = 'Sending…'; err.textContent = '';
        send('complete')
          .then(function (out) {
            if (out && out.ok) { barFill.style.width = '100%'; show(screens.thanks); trackComplete(); }
            else throw new Error('failed');
          })
          .catch(function () {
            btn.disabled = false; btn.textContent = 'Submit and enter the draw';
            err.textContent = 'Something went wrong. Please try again.';
          });
      });
      return wrap;
    }

    function advance() {
      index += 1;
      if (index < QUESTIONS.length) { progress(); show(questionScreen(QUESTIONS[index])); }
      else { progress(); show(finalScreen()); }
    }

    // Intro: email gate
    var startForm = el(root, '[data-glq-start-form]');
    if (startForm) {
      startForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var err = startForm.querySelector('[data-glq-err]');
        var v = (startForm.email.value || '').trim();
        if ((startForm.company && startForm.company.value || '').trim()) return;
        if (!validEmail(v)) { err.textContent = 'That email does not look right.'; return; }
        err.textContent = '';
        email = v.toLowerCase();
        send('started').catch(function () {});
        advance();
      });
    }

    if (instagram) {
      var ig = el(root, '[data-glq-ig]');
      if (ig) ig.setAttribute('href', instagram);
    }
    progress();
    screens.intro.classList.add('is-live');
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-glq-root]'), boot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
